/*
 * @Author: huangzq
 * @Date: 2019-09-27 11:34:33
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-11-20 17:21:18
 * @Desc: 营销资料-海报tab项
*/
<template>
  <div class="poster-tab">
    <!-- 搜索栏 -->
    <search-line @on-search="onSearch" />

    <div class="infinite-scroll-wrapper">
      <infinite-scroll
        ref="infiniteScroll"
        :api="api"
        @on-load-over="onLoadOver"
      >
        <!-- 列表内容 -->
        <div class="create-wrapper marketing-data-create-wrapper-209">
          <div
            class="template-create"
            @click="templateCreateFun"
          >
            <mk-iconfont
              icon-class="xinzeng"
              class="plus-icon"
            />
            <div>模板创建</div>
          </div>
          <div
            class="empty-create"
            @click="emptyCreateFun"
          >
            空白创建
          </div>
        </div>

        <item
          v-for="(item,index) in dataList"
          :key="item._id+item.status+item.updateTime"
          class="marketing-data-mk-data-item-209"
          :item-data="item"
          :other-api="otherApi"
          :type="type"
          @edit-item="editItem(item)"
          @delete-item="deleteItem(index)"
          @update-item="itemData=>updateItem(itemData,index)"
          @on-preview-set="onPreviewSet(item,index)"
        />
      </infinite-scroll>
    </div>

    <!-- 预览和设置弹窗 -->
    <preview-set
      :visible.sync="isShowSetAndPreviewDialog"
      :material-data="currPosterItem"
      :other-api="otherApi"
      @on-confirm="previewSetConfirm"
    />
  </div>
</template>

<script>
import { MKMATERIALSVC } from '@api'

import SearchLine from '../common/search-line'
import InfiniteScroll from '@components/infinite-scroll'
import Item from '../common/item'
import PreviewSet from './preview-set'

export default {
  name: 'PosterTab',
  components: { SearchLine, InfiniteScroll, Item, PreviewSet },
  data () {
    return {
      type: 'poster',
      // * 获取列表的接口的相关数据
      api: {
        // 接口名称
        promiseFun: MKMATERIALSVC.PosterApi.posterPost,
        // 接口参数；分页参数已经放在infiniteScroll组件里面了，所以这块写除了分页的其他参数
        params: {
          showTags: true
        }
      },
      // 其他接口
      otherApi: {
        delete: MKMATERIALSVC.PosterApi.posterDelete,
        publish: MKMATERIALSVC.PosterApi.posterPut,
        update: MKMATERIALSVC.PosterApi.posterPut,
        find: MKMATERIALSVC.PosterApi.posterGet
      },

      // * 数据列表
      dataList: [],

      // * 当前某块海报数据
      currPosterItem: {},

      // * 当前某块Poster数据的下标
      currPosterIndex: 0,

      // 是否显示预览和设置弹窗
      isShowSetAndPreviewDialog: false
    }
  },

  methods: {
    // * 搜索事件：返回最新的搜索条件值，然后执行infinite-scroll组件的获取列表方法
    onSearch (searchParams) {
      this.dataList = []
      this.$refs.infiniteScroll.resetPage(searchParams)
    },

    // * 滚动加载数据完毕，返回新获取的数据
    onLoadOver (list) {
      this.dataList.push(...list)
    },

    /**
     * * 模板创建点击：跳转到【官方模板页面】
     */
    templateCreateFun () {
      sessionStorage.setItem('official-template-library-tab-name', this.type)

      this.$router.push({
        path: '/marketing-content/official-template-library'
      })
    },

    // * 空白创建：在新标签页 打开 {海报编辑器}
    emptyCreateFun () {
      window.open(this.util.createEditorUrl(this.type, 'mk', { backPath: encodeURIComponent(`/${location.hash}`) }))
    },

    // * 编辑某个海报：新标签页打开 {海报编辑器}
    editItem (item) {
      const { _id } = item
      window.open(this.util.createEditorUrl(this.type, 'mk', { materialId: _id, backPath: encodeURIComponent(`/${location.hash}`) }))
    },

    // * 删除某个海报：通过index，使用Array.splice来删除
    deleteItem (index) {
      this.dataList.splice(index, 1)
    },

    /**
     * * 更新某个海报数据：
     * * 有id时：通过id获取最新的数据，然后再更新
     * * 无id时：使用传递过来的数据更新
     */
    async updateItem (itemData, index) {
      if (itemData._id) {
        // 通过接口，重新获取当前id的最新数据
        const res = await this.otherApi.find({
          _id: itemData._id
        })

        if (res.success) {
          // 将最新数据放到对应下标的dataList中
          this.$set(this.dataList, index, res.data)
        }
      } else {
        // 不通过接口，更新某个数据
        // 主要针对于状态的改变
        const newItemData = { ...this.dataList[index], ...itemData }
        this.$set(this.dataList, index, newItemData)
      }
    },

    // * 显示预览和设置弹窗
    onPreviewSet (itemData, index) {
      this.currPosterItem = itemData
      this.currPosterIndex = index
      this.isShowSetAndPreviewDialog = true
    },

    // 预览&设置-保存事件
    async previewSetConfirm (materialData) {
      const res = await this.otherApi.update(materialData)
      if (res.success) {
        this.$message({
          type: 'success',
          message: '修改成功！'
        })
        this.isShowSetAndPreviewDialog = false
        this.updateItem(this.currPosterItem, this.currPosterIndex)
      } else {
        this.$message({
          type: 'error',
          message: '修改失败，请重试！'
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.poster-tab {
  .infinite-scroll-wrapper {
    flex: 1;
    overflow: hidden;

    .infinite-scroll {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      overflow: auto;
      padding: 0 20px;

      & > div {
        margin-right: 24px;
        margin-bottom: 24px;
      }

      .create-wrapper {
        .template-create {
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          width: 260px;
          height: 260px;
          margin-bottom: 24px;

          .plus-icon {
            font-size: 26px;
            margin-bottom: 18px;
          }
        }

        .empty-create {
          line-height: 58px;
          height: 58px;
          text-align: center;
        }

        & > div {
          border: 1px dashed #d9d9d9;
          background-color: #fafafa;
          color: #595959;
          font-size: 14px;

          @extend .cursor;
        }
      }
    }
  }
}
</style>
